import type { NumberFormatterOptions } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import { AmountType, CalculateByField } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type {
  DimensionDescriptor,
  FunctionDescription,
  MeasureDataset,
} from "../../../../../../../../../api/types/svTypes.ts";
import type { FormulaNode } from "../utilities/fillNodes";
import type { INode } from "../utilities/formulaParser";
import type { Token } from "../utilities/tokenizer";

export type CustomMeasureState = {
  rootNode?: INode;
  formulaNodes: FormulaNode[];
  dimensions: DimensionDescriptor[];
  functions: FunctionDescription[];
  currentToken?: Token;
  caption?: string;
  group?: string;
  subgroupId?: string;
  calculateBy?: CalculateByField;
  formula?: string;
  format?: NumberFormatterOptions;
  functionHovered?: Token | undefined;
  selectedFormulaParameter?: Token | undefined;
  amountType?: AmountType;
  nodesCounter?: NodesCounter;
  dataSets: MeasureDataset[];
  isConfigurable?: boolean;
};

export type NodesCounter = {
  nodeVariable: number;
  nodeFunction: number;
  nodeNumber: number;
};

export const initialState: CustomMeasureState = {
  formulaNodes: [],
  dimensions: [],
  functions: [],
  caption: "",
  calculateBy: CalculateByField.Lcy,
  amountType: AmountType.Net,
  dataSets: [],
};
